// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  USER_CHOOSE_CURRENT_FRUI_ZZZZ_MODEL_SHOW,
} from './constants';

export function chooseCurrentFruiZzzzModelShow(visible) {
  return {
    type: USER_CHOOSE_CURRENT_FRUI_ZZZZ_MODEL_SHOW,
    data:{visible}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_CHOOSE_CURRENT_FRUI_ZZZZ_MODEL_SHOW:
      return {
        ...state,
        userchooseCurrentFrui_zzzzModalVisible:action.data.visible,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFruiZzzzModelShow.js